import { render } from "./CustomerServiceProviderCompanyCreditAndAccountingPeriodForm.vue?vue&type=template&id=4ee808d1&scoped=true&ts=true"
import script from "./CustomerServiceProviderCompanyCreditAndAccountingPeriodForm.vue?vue&type=script&lang=ts"
export * from "./CustomerServiceProviderCompanyCreditAndAccountingPeriodForm.vue?vue&type=script&lang=ts"

import "./CustomerServiceProviderCompanyCreditAndAccountingPeriodForm.vue?vue&type=style&index=0&id=4ee808d1&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee808d1"]])

export default __exports__